import React from 'react';
import { observer } from 'mobx-react';
import { SignatureDocument, SignatureStore } from '../../stores/signature.store';
import { DocumentListItemCard } from '../document-list-item-card/document-list-item-card';
import { getDocumentName, isProjectSignature } from 'src/signature/util/document-utils';
import { signatureContainer } from 'src/signature/ioc';

interface DocumentListItemProps {
    item: SignatureDocument;
    onClick: (item: SignatureDocument) => void;
}

export const DocumentListItem: React.FC<DocumentListItemProps> = observer(({ item, onClick }) => {
    const signaturesStore = signatureContainer.get(SignatureStore);

    const onClickItem = () => {
        onClick(item);
    };

    return (
        <DocumentListItemCard
            name={getDocumentName(item)}
            signed={!!item.signedOn}
            signedOn={item.signedOn}
            requestedOn={item.requestedOn}
            tenantTimeZone={signaturesStore.tenantTimeZone}
            isProject={isProjectSignature(item)}
            onClick={onClickItem}
        />
    );
});
